// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  --ion-item-background: #EDEDED;
}

ion-item {
  --inner-border-width: 0 0 0 0 !important;
}

ion-button {
  margin-top: 3px;
  margin-right: 0px;
  font-weight: bold;
}

h2 {
  margin-top: 9px;
  font-size: 18px;
  font-weight: 600;
}

h5 {
  font-size: 16px;
  font-weight: bold !important;
  margin: 5px 0 !important;
}

h6 {
  font-size: 16px;
  font-weight: 550;
  margin: 5px 0 !important;
}

.content-balance {
  background-color: #EDEDED;
  padding: 6px;
}

.accordian-btn {
  margin-left: auto;
  margin-right: auto;
  font-weight: 600;
  width: 200px;
  border-radius: 0 0 10px 10px;
  display: flex;
  justify-content: center;
  padding: 6px;
  background-color: #EDEDED;
}
.accordian-btn ion-icon {
  padding-right: 10px;
}
.accordian-btn b {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/balance/balance.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ;;AAEA;EACI,wCAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;EACA,4BAAA;EACA,wBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;AACJ;AACI;EACI,mBAAA;AACR;AAEI;EACI,eAAA;AAAR","sourcesContent":["ion-grid {\n    --ion-item-background: #EDEDED;\n}\n\nion-item {\n    --inner-border-width: 0 0 0 0 !important;\n}\n\nion-button{\n    margin-top: 3px;\n    margin-right: 0px;\n    font-weight: bold;\n}\n\nh2{\n    margin-top: 9px;\n    font-size: 18px;\n    font-weight: 600;\n}\n\nh5{\n    font-size: 16px;\n    font-weight: bold!important;\n    margin: 5px 0!important;\n}\n\nh6{\n    font-size: 16px;\n    font-weight: 550;\n    margin: 5px 0!important;\n}\n\n.content-balance {\n    background-color: #EDEDED;\n    padding: 6px;\n}\n\n.accordian-btn {\n    margin-left: auto;\n    margin-right: auto;\n    font-weight: 600;\n    width: 200px;\n    border-radius: 0 0 10px 10px;\n    display: flex;\n    justify-content: center;\n    padding: 6px;\n    background-color: #EDEDED;\n    \n    ion-icon {\n        padding-right: 10px;\n    }\n\n    b{\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
